<form [formGroup]="filterForm">
  <p-card>
    <ng-template #header>
      <div class="flex items-center gap-2">
        <span>{{ 'Filters' | translateWF: 'Filters' }}</span>
      </div>
    </ng-template>

    <div class="form-box">
      <label for="knittingOrderNumber">
        {{ 'Order_Number' | translateWF: 'Order Number' }}
      </label>
      <input id="knittingOrderNumber" pInputText type="text" class="w-full" formControlName="knittingOrderNumber" />
    </div>

    <div class="form-box">
      <label for="statuses">
        {{ 'Status' | translateWF: 'Status' }}
      </label>
      <p-multiSelect
        id="statuses"
        formControlName="statuses"
        [options]="statusOptionsArray"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'Select_Status' | translateWF: 'Select Status'"
        [style]="{ width: '100%' }"
        display="chip"
      ></p-multiSelect>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex gap-[1rem] mt-[4rem]">
        <p-button [label]="'Reset' | translateWF: 'Reset'" variant="outlined" (click)="resetFilters()" />
        <p-button [label]="'Apply' | translateWF: 'Apply'" (click)="applyFilters()" />
      </div>
    </ng-template>
  </p-card>
</form>
